module.exports = __webpack_public_path__ + "img/mascot-print-page.d022a262.png";